export const getInitialsList = ()=>([
  {id: 1, title: "Mr"},
  {id: 2, title: "Mrs"},
  {id: 3, title: "Miss"}
])
